import { render, staticRenderFns } from "./TuitionFeePaymentReport.vue?vue&type=template&id=4b0c1456"
import script from "@/controllers/custom/report/tuition-fee-payment-report.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/report/tuition-fee-payment-report.js?vue&type=script&lang=js&external"
import style0 from "./TuitionFeePaymentReport.vue?vue&type=style&index=0&id=4b0c1456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports